import { memo } from 'react'
import VerticalLayout from '../../VerticalLayout'

const LayoutWrapper = ({ children, routeMeta }) => (
  <VerticalLayout routeMeta={routeMeta}>
    {children}
  </VerticalLayout>
)

export default memo(LayoutWrapper)